(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amra-reveal"] && !Shopify.designMode) return;
  try {
    
function amraColorFilters(root){
  root.querySelectorAll('[data-amra-discover]').forEach(section=>{
    if(section.dataset.ready)return;section.dataset.ready='true';
    const filters=section.querySelector('.amra-discover__filters');filters.hidden=false;
    filters.addEventListener('click',e=>{
      const button=e.target.closest('button[data-color]');if(!button)return;
      filters.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      let count=0;section.querySelectorAll('.amra-discover__card').forEach(card=>{card.hidden=button.dataset.color!=='all'&&card.dataset.color!==button.dataset.color;if(!card.hidden)count++;});
      section.querySelector('.amra-discover__empty').hidden=count>0;
    });
  });
}
amraColorFilters(document);
document.addEventListener('shopify:section:load',e=>amraColorFilters(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amra-signature"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('amra-signature-controller')) {
  class AmraSignatureController extends HTMLElement {
    connectedCallback() {
      const root = this.parentElement;
      const slides = Array.from(root.querySelectorAll('[data-amra-slide]'));
      if (slides.length < 2) return;
      const controls = root.querySelector('[data-amra-controls]');
      const pause = root.querySelector('[data-amra-pause]');
      const count = root.querySelector('[data-amra-count]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mobile = window.matchMedia('(max-width: 799px)');
      let current = 0, stopped = reduced.matches, hovering = false, focused = false, timer;
      const sync = () => {
        clearInterval(timer);
        const label = stopped ? pause.dataset.play : pause.dataset.pause;
        pause.setAttribute('aria-label', label);
        count.setAttribute('aria-live', stopped ? 'polite' : 'off');
        pause.querySelector('[data-amra-pause-label]').textContent = label;
        if (!stopped && !hovering && !focused && !document.hidden) timer = setInterval(() => show(current + 1), mobile.matches ? 10000 : 5000);
      };
      const show = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { const inactive = i !== current; slide.hidden = inactive; slide.inert = inactive; slide.setAttribute('aria-hidden', String(inactive)); });
        count.textContent = String(current + 1).padStart(2,'0') + ' / ' + String(slides.length).padStart(2,'0');
      };
      const previous = () => { stopped = true; show(current - 1); sync(); };
      const next = () => { stopped = true; show(current + 1); sync(); };
      const toggle = () => { stopped = !stopped; sync(); };
      const enter = () => { hovering = true; sync(); };
      const leave = () => { hovering = false; sync(); };
      const focusIn = () => { focused = true; sync(); };
      const focusOut = e => { if (!root.contains(e.relatedTarget)) { focused = false; sync(); } };
      const motion = () => { stopped = reduced.matches; sync(); };
      const touch = e => { if (e.pointerType === 'touch') { stopped = true; sync(); } };
      const listeners = [[root.querySelector('[data-amra-prev]'),'click',previous],[root.querySelector('[data-amra-next]'),'click',next],[pause,'click',toggle],[root,'mouseenter',enter],[root,'mouseleave',leave],[root,'focusin',focusIn],[root,'focusout',focusOut],[document,'visibilitychange',sync],[reduced,'change',motion],[mobile,'change',motion],[root.querySelector('.amra-signature__slides'),'pointerdown',touch]];
      listeners.forEach(([target,event,handler]) => target.addEventListener(event,handler));
      show(0); root.setAttribute('data-amra-ready', ''); controls.hidden = false; sync();
      this.cleanup = () => { clearInterval(timer); listeners.forEach(([target,event,handler]) => target.removeEventListener(event,handler)); };
    }
    disconnectedCallback() { if (this.cleanup) this.cleanup(); }
  }
  customElements.define('amra-signature-controller', AmraSignatureController);
}
const mount = scope => scope.querySelectorAll('[data-amra-carousel]').forEach(root => {
  if (!root.querySelector('amra-signature-controller')) root.appendChild(document.createElement('amra-signature-controller'));
});
mount(document);
document.addEventListener('shopify:section:load', event => mount(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
